import { createConstant } from '../helpers';
const createConstantVariable = createConstant('loading');

export const SET_LOADING = createConstantVariable('SET_LOADING');
export const SET_PERCENT = createConstantVariable('SET_PERCENT');



// WEBPACK FOOTER //
// ./src/redux/loading/constants.js